<template>
    <el-dialog title="地址信息"  :visible="dialogVisible"  width="650px" center :close-on-click-modal=false :before-close="handleCloseDialog">
        <el-form :model="form" ref="form" :rules="rules" class="demo-ruleForm" >
            <el-form-item label="收件人姓名" :label-width="formLabelWidth" prop="name" >
                <el-input v-model="form.name"  auto-complete="off" placeholder="请输入收件人姓名" ></el-input>
            </el-form-item>
            <el-form-item label="联系方式" :label-width="formLabelWidth" prop="mobile">
                <el-input v-model="form.mobile" auto-complete="off" placeholder="请输入联系方式"></el-input>
            </el-form-item>
            <DistrictLinkage :itemLabelWidth="formLabelWidth" :provinceId="form.province_id"  :cityId="form.city_id" :districtId="form.district"  @change="handleChange"></DistrictLinkage>
            <el-form-item label="地址" :label-width="formLabelWidth" prop="address" >
                <el-input v-model="form.address" auto-complete="off" placeholder="请输入详细地址"></el-input>
            </el-form-item>
            <el-form-item label="邮寄方式" :label-width="formLabelWidth" prop="express_company">
                <el-select v-model="form.express_company" placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="备注信息" :label-width="formLabelWidth">
                <el-input v-model="form.memo" auto-complete="off"></el-input>
            </el-form-item>
            <!-- <el-row>
                <el-form-item label="单号" :label-width="formLabelWidth" prop="express_no">
                    <el-input v-model="form.express_no" auto-complete="off" placeholder="请输入快递单号"></el-input>
                </el-form-item>
            </el-row>
                <el-form-item label="签收状态" :label-width="formLabelWidth" prop="status" inline-message=true>
                    <el-select v-model="form.status" placeholder="请选择">
                        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            <el-row>
                <el-form-item label="邮费" :label-width="formLabelWidth" prop="fee">
                    <el-input v-model.number="form.fee" auto-complete="off"></el-input>
                </el-form-item>
            </el-row> -->
                
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCloseDialog">关闭</el-button>
            <el-button type="primary" @click="handleSubmit">保存</el-button>
        </div>
    </el-dialog>
</template>
<style scoped>
.app-main .main-bd .el-row {
    padding: 20px 0;
}
.my-input-width{
    width: 58px;
}
</style>
<script>
import OrderService from '~/services/order';
import DistrictLinkage from "~/widgets/DistrictLinkage.vue";
import DistrictService from "~/services/district";
import { isNumber } from 'util';
export default {
props:{
    expressForm: null
},
components:{
    DistrictLinkage
},

data() {
    var checkFee = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('邮费不能为空'));
            } else if(isNaN(value)){
                return callback(new Error('邮费必须为数字'));
            } else if(value<0) {
                return callback(new Error('邮费必须大于0'));
            } else {
                callback();
            }
        };

    var checkMobile = (rule,value,callback) => {
        if (!value) {
                return callback(new Error('请输入收件人联系方式'));
            }
            // var reg= /^((13|14|15|17|18|19|16)[0-9]{1}\d{8})$/;
            // if(!reg.test(value)){
            //     return callback(new Error('请输入正确的手机号'));
            // }
            callback();
    }    
    return {
        dialogVisible: true,
        options: [],
        statusOptions: [],
        provices:[],
        citys:[],
        districts:[],
        form: {
            id:'',
            status:0,
            express_company:'',
            express_no:'',
            express_fee:'',
            name:'',
            mobile:'',
            address:'',
            province_id: 0,
            city_id: 0,
            district: 0,
            label_name:'',//城市地区名称
            district_id:'',
        },
        rules: {
            status: [
                { required: true, message: '请选择快递状态', trigger: 'blur' },
            ],
            express_company: [
                { required: true, message: '请选择邮寄方式', trigger: 'blur' },
            ],
            express_no: [
                { required: true, message: '请输入订单号', trigger: 'blur' },
            ],
            express_fee: [
                { required: true, message: '请输入快递费用', trigger: 'blur' },
            ],
            name:[
                { required: true, message: '请输入收件人', trigger: 'blur'  }
            ],
            mobile:[
                { required: true, validator: checkMobile, trigger: 'blur'  }
            ],
            address:[
                { required: true, message: '请输入详细地址', trigger: 'blur'  }
            ],
            province_id:[
                { required: true, message: '请选择地区', trigger: 'change'  }
            ],
            city_id:[
                { required: true, message: '请选择地区', trigger: 'change'  }
            ],
            district:[
                { required: true, message: '请选择地区', trigger: 'change' }
            ],
            district_id:[
                { required: true, message: '请选择所在地区', trigger: 'blur' }
            ],
            fee:[
                { required: true,validator: checkFee, trigger: 'blur' }
            ]
        },
        formLabelWidth: '100px'
    };
},
created() {
    this.options = OrderService.options();
    this.statusOptions = OrderService.statusOptions();
    if (this.expressForm) {
        this.form = Object.assign({}, this.expressForm)
    }
},
methods:{
    handleSubmit(done){
        let province;
        let city;
        let dis;
        province = this.provices.find(item=>{
            return item.id  == this.form.province_id;
        })
        city = this.citys.find(item=>{
            return item.id  == this.form.city_id;
        })
        dis = this.districts.find(item=>{
            return item.id  == this.form.district;
        })
        this.form.label_name = '';
        if(province) this.form.label_name += province.name;
        if(city) this.form.label_name += city.name;
        if(dis) this.form.label_name += dis.name;
        this.$refs["form"].validate(valid => {
            if (valid) {
                this.$delete(this.form,'district_id')
                this.dialogVisible = false;
                this.$emit("handleAddExpress", this.form);
            } else {
                return false;
            }
        });
    },
    handleCloseDialog(){
        this.dialogVisible = false;
        this.$emit("handleAddExpress");
    },
    handleChange(value) {
        this.form.province_id = parseInt(value[0]);
        this.form.city_id = parseInt(value[1]);
        this.form.district = parseInt(value[2]);
        this.$set(this.form, 'district_id', value.every((item)=>item!=0)?'1':null)
        this.combineData();
    },
    combineData(){
        DistrictService.getProvinces().then(res=>{
            this.provices = res.data;
        })
        if(this.form.province_id){
            DistrictService.getCities(this.form.province_id).then(res=>{
                this.citys = res.data;
            });
        }
        if(this.form.city_id){
            DistrictService.getDists(this.form.city_id).then(res=>{
                this.districts = res.data;
            });
        }
    }
}
}
</script>




// WEBPACK FOOTER //
// src/views/order/expressTable.vue